import { normalizeBackgroundMapForPersistence, normalizeBackgroundPersistenceValue } from './presetTemplates';

export const applyScopedSlideBackground = ({
  existingBackgrounds = {},
  regularSlideIds = [],
  scope = 'current',
  targetSlideId,
  background
}) => {
  const next = { ...normalizeBackgroundMapForPersistence(existingBackgrounds) };
  const normalizedBackground = normalizeBackgroundPersistenceValue(background);

  if (scope === 'all') {
    regularSlideIds.forEach((slideId) => {
      if (!slideId) return;
      if (normalizedBackground) {
        next[slideId] = normalizedBackground;
      } else {
        delete next[slideId];
      }
    });
    return next;
  }

  if (!targetSlideId) return next;
  if (normalizedBackground) {
    next[targetSlideId] = normalizedBackground;
  } else {
    delete next[targetSlideId];
  }
  return next;
};
